import Icons from "../../assets/icons/index.js";
import {
  Btn,
  InputField,
  FormHeading,
  AuthLayout,
  Loader,
} from "../../components/index";
import { fontSizes } from "../../constants/constants.js";
import OtpVerifyFunction from "./index.function.js";
const VerificationCode = () => {
  const {
    register,
    handleSubmit,
    setValue,
    errors,
    resendOtpHandler,
    onSubmit,
    loadingToapi,
    TextWeight,
  } = OtpVerifyFunction();
  return (
    <AuthLayout isBackBnt={true} isPath={"/forgetPassword"}>
      <FormHeading
        title="Verify Your"
        highlightText={"Code"}
        description={
          "Please enter the verification code sent to your email or phone number to confirm your identity. If you have not yet received any code, you can have it resent."
        }
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className=" my-1">
          <label className="font-raleway text-sm sm:text-base font-bold 2xl:text-lg">
            Enter Code
          </label>

          <div className="relative my-2">
            <InputField
              type="text"
              name="otpCode"
              placeholder="xxx - xxx -xx"
              cardIcon={Icons.checkIcon}
              {...register("otpCode", { required: "Email is required" })} // This registers the input with react-hook-form
              onChange={(value) => setValue("otpCode", value)}
              // icon={Icons.EmailIcons}
              iconStyle={"w-5 h-5 sm:w-5 sm:h-5 lg:h-5 lg:w-6 2xl:w-7 2xl:h-6"}
            />
            {errors.otpCode && (
              <span style={{ color: "red" }}>{errors.otpCode.message}</span>
            )}
          </div>
          <Btn
            type={"submit"}
            isDisabled={loadingToapi}
            loading={loadingToapi}
            isprimary={false}
            weight={TextWeight.Raleway_SemiBold}
            textSize={fontSizes.h18}
            text={"Continue"}
            color="text-white"
            hover={"hover:text-primary hover:bg-white hover:border-primary"}
            bgColor={"bg-primary border-transparent"}
            className={"mt-4 mx-auto"}
          />
          <Btn
            type={"button"}
            weight={TextWeight.Raleway_SemiBold}
            textSize={fontSizes.h18}
            text={"send again"}
            color="text-[#707070] hover:text-primary"
            bgColor={"bg-transparent"}
            className={"mt-2 mx-auto underline border-transparent"}
            onClick={resendOtpHandler}
          />
        </div>
      </form>
    </AuthLayout>
  );
};

export default VerificationCode;
